const UploadImage = {
  ///////////////////////////////////////////
  //// Dados do Cloudinary
  ///////////////////////////////////////////
  config: {
    cloudName: 'dyr8ktx3p',
    uploadPreset: 'dyr8ktx3p',
    allowedTypes: [
      'image/png',
      'application/pdf',
    ]
  },
  ///////////////////////////////////////////
  //// Validação do tipo do arquivo
  ///////////////////////////////////////////
  validateFile: function (file) {
    if (!this.config.allowedTypes.includes(file[0].type)) {
      console.error('Formato não permitido do arquivo: ', file[0])
      return false
    }
    console.log('Formato do arquivo permitido: ', file[0])
    return true
  },

  upload: async function (file) {
    try {
      ///////////////////////////////////////////
      //// Implementação com Cloudinary
      ///////////////////////////////////////////

      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', this.config.uploadPreset);
      formData.append('folder', 'user_uploads'); // Configurado no Cloudinary
      formData.append('tags', 'web_upload'); // Para melhor gerenciamento
      formData.append('context', `filename=${encodeURIComponent(file.name)}`);

      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${this.config.cloudName}/image/upload`,
        {
          method: 'POST',
          body: formData,
          referrerPolicy: 'no-referrer' // Header de segurança
        }
      );

      if (!response.ok) {
        const error = await (response.json());
        throw new Error(error.message || 'Erro no upload');
      }

      const data = await response.json();

      console.log('link gerado: ', data.secure_url);

      return data.secure_url

    } catch (error) {
      console.error('Erro no upload: ', error);
      this.showError(error.message);
    }
  }
}

export default UploadImage;
